// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImagesGallery {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 20px;
}

.imgGallery {
    width: 200px;
    height: 120px;
    margin: 5px;
    cursor: pointer;
}

.imgGalleryCont {
    display: flex;
    flex-direction: column;
    position: relative;
}

.deleteImg {
    position: absolute;
    top: 5px;
    right: 5px;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    border: none;
    padding: 5px;
    cursor: pointer;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.imgGalleryCont:hover .deleteImg {
    opacity: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/MonitorPage/monitorManager/ImagesGallery.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,8BAA8B;IAC9B,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd","sourcesContent":[".ImagesGallery {\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: center;\r\n    margin-top: 20px;\r\n}\r\n\r\n.imgGallery {\r\n    width: 200px;\r\n    height: 120px;\r\n    margin: 5px;\r\n    cursor: pointer;\r\n}\r\n\r\n.imgGalleryCont {\r\n    display: flex;\r\n    flex-direction: column;\r\n    position: relative;\r\n}\r\n\r\n.deleteImg {\r\n    position: absolute;\r\n    top: 5px;\r\n    right: 5px;\r\n    background: rgba(0, 0, 0, 0.5);\r\n    color: white;\r\n    border: none;\r\n    padding: 5px;\r\n    cursor: pointer;\r\n    opacity: 0;\r\n    transition: opacity 0.3s ease;\r\n}\r\n\r\n.imgGalleryCont:hover .deleteImg {\r\n    opacity: 1;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
